<template>
    <b-modal
        id="modal-details-video"
        ref="modal-details-video"
        centered
        ok-only
        ok-title="Cerrar"
        ok-variant="secondary"
        :title="modalTitle"
        size="lg"
        @show="onShow()"
        @hidden="resetForm()"
    >
        <LazyYoutubeVideo
            v-if="selectedCrudObject"
            autoplay
            :src="`https://www.youtube.com/embed/${selectedCrudObject.url}`"
        />
    </b-modal>
</template>

<script>
import LazyYoutubeVideo from 'vue-lazy-youtube-video'
import { mapState, mapActions } from 'vuex'

export default {
    name: 'VideoDetailsModal',
    components: {
        LazyYoutubeVideo
    },
    data () {
        return {
            formDisabled: false,
            form: {
                name: '',
                url: ''
            }
        }
    },
    computed: {
        ...mapState([
            'activeSite',
            'selectedCrudObject'
        ]),
        modalTitle () {
            var title = 'Ver Video'
            if (this.selectedCrudObject) {
                title = title + `: ${this.selectedCrudObject.name}`
            }
            return title
        }
    },
    methods: {
        ...mapActions([
            'increaseSiteVideoViews',
            'readCourseSiteByAcademicPeriod'
        ]),
        async onShow () {
            // Increase the view/click count of the video when the modal is opened.
            try {
                var payloadData = { videoId: this.selectedCrudObject.id, courseSiteId: this.activeSite.id }
                await this.increaseSiteVideoViews(payloadData)
                this.$store.commit('INCREASE_VIDEO_CLICK_COUNT', this.selectedCrudObject.id)
            } catch (err) {
                console.log({ err: err })
            }
        },
        resetForm () {
            this.$store.commit('RESET_SELECTED_CRUD_OBJECT')
        }
    }
}
</script>
